/**
 * Notification Settings Page
 */

import { Card, Heading, Stack, Text } from '@cortex/ui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/notifications')({
  component: NotificationSettingsPage,
});

function NotificationSettingsPage() {
  return (
    <Stack>
      <Heading level={1} className="mb-6 text-2xl font-semibold">
        Notification Settings
      </Heading>

      <Card className="max-w-2xl p-6">
        <Text color="secondary">
          Notification preferences will be available here.
        </Text>
      </Card>
    </Stack>
  );
}
